class CadastroEtiquetaModal {
    static get $inject() {
        return ['$scope', 'gql', 'Etiquetas']
    }

    constructor($scope, gql, Etiquetas) {
        this.apply = fn => $scope.$apply(fn)
        this.gql = gql

        this.Etiquetas = Etiquetas

        this.etiqueta = { empresas: [] }
    }

    $onInit() {
        const empresaId = this.resolve.empresaId.toString()

        this.promise = this
            .loadEmpresas()
            .then(empresas => {
                this.empresas = empresas.reject(empresa => empresa.id === empresaId)
                this.empresa = empresas.find(e => e.id === empresaId)
            })
            .catch(console.error)
            .finally(() => this.apply())

        if (this.resolve.etiqueta) {
            const { id, cor, nome, descricao } = this.resolve.etiqueta

            if (id) {
                this.etiqueta = { id, cor, nome, descricao, empresas: [] }
            } else {
                this.etiqueta = { ...this.etiqueta, ...this.resolve.etiqueta }
            }
        }
    }

    loadEmpresas() {
        const query = gql`
            query EmpresasList {
                usuarioAtual {
                    id
                    permissoes {
                        id
                        empresa {
                            id
                            raizCnpj
                            razaoSocial
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query)
            .then(({ usuarioAtual: { permissoes } }) =>
                permissoes
                    .map(p => p.empresa)
                    .sortBy(p => p.razaoSocial)
            )
    }

    submit() {
        if (this.form.$valid) {
            this.submitPromise = this
                .createOrUpdateEtiqueta(this.etiqueta)
                .then(etiqueta =>
                    this.close({ $value: etiqueta })
                )
                .catch(errors => errors.forEach(e => this.handleError(e)))
                .finally(() => this.apply())
        }
    }

    handleError({ key }) {
        switch (key) {
            case 'nome':
                return this.form.nome.$setValidity('alreadyExists', false)
        }
    }

    createOrUpdateEtiqueta(etiqueta) {
        const { id: etiquetaId, empresas, ...etiquetaParams } = etiqueta

        const promise = etiquetaId
            ? this.Etiquetas.updateEtiqueta(this.empresa.id, etiquetaId, etiquetaParams)
            : this.Etiquetas.createEtiqueta(this.empresa.id, etiquetaParams)
            
        return promise
            .then(etiqueta => {
                if (empresas.length) {
                    return this.Etiquetas
                        .replicateEtiqueta(this.empresa.id, etiqueta, empresas)
                        .catch(console.error)
                        .then(() => etiqueta)
                } else {
                    return etiqueta
                }
            })
            .finally(() => this.apply())
    }

    resetForm() {
        this.form.nome.$setValidity('alreadyExists', true)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('cadastroEtiquetaModal', {
        controller: CadastroEtiquetaModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <form name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate>
            <modal modal-title="Cadastro de etiquetas" close="$ctrl.close">
                <modal-body>
                    <loading promise="$ctrl.promise">
                        <div class="row">
                            <div class="form-group col-xs-12">
                                <label>Nome</label>
                                <input 
                                    name="nome" 
                                    class="form-control" 
                                    ng-model="$ctrl.etiqueta.nome" 
                                    ng-change="$ctrl.resetForm()"
                                    required>
                                <div ng-messages="$ctrl.form.nome.$error" ng-if="$ctrl.form.$submitted">
                                    <span 
                                        class='help-block txt-color-red font-xs no-margin' 
                                        ng-message="required">Informe um nome para a etiqueta.
                                    </span>
                                    <span 
                                        class='help-block txt-color-red font-xs no-margin' 
                                        ng-message="alreadyExists">Já existe outra etiqueta com este nome.
                                    </span>
                                </div>
                            </div>
                            
                            <div class="form-group col-xs-12">
                                <label>Descrição</label>
                                <textarea 
                                    class="form-control" 
                                    ng-model="$ctrl.etiqueta.descricao" 
                                    style="resize: vertical"
                                    maxlength="200">
                                </textarea>
                                <div class="text-muted text-right">
                                    <small>Limite de caracteres: {{$ctrl.etiqueta.descricao.length || 0}}/200</small>
                                </div>
                            </div>

                            <div class="col-xs-12">
                                <label>Cor</label>
                                <ef-color-picker ng-model="$ctrl.etiqueta.cor" name="cor" required>
                                </ef-color-picker>
                                <div ng-messages="$ctrl.form.cor.$error" ng-if="$ctrl.form.$submitted">
                                    <span 
                                        class='help-block txt-color-red font-xs no-margin' 
                                        ng-message="required">Selecione alguma das cores acima.
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row" style="margin-top: 13px" ng-if="$ctrl.empresas.length">
                            <div class="col-xs-12">
                                <label>Replicar etiqueta para as seguintes empresas:</label>
                                <div ng-repeat="empresa in $ctrl.empresas">
                                    <label>
                                        <input  
                                            checklist-model="$ctrl.etiqueta.empresas"
                                            checklist-value="empresa.id"
                                            type="checkbox" 
                                            class="checkbox" />
                                        <span>
                                            {{empresa.razaoSocial}} - <span class="text-muted">{{empresa.raizCnpj | cpfCnpj}}</span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </loading>
                </modal-body>
                <modal-footer>
                    <promise-tracker promise="$ctrl.submitPromise" active="isActive">
                        <button class="btn btn-primary" ng-disabled="isActive">
                            <span ng-hide="isActive">Salvar</span>
                            <span ng-show="isActive">Salvando...</span>
                        </button>
                        <button 
                            class="btn btn-default" 
                            type="button"
                            ng-click="$ctrl.close()">
                            Fechar
                        </button>
                    </promise-tracker>
                </modal-footer>
            </modal>
        </form>
        `
    })
